import React from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import Img from "../../assets/images/sample.webp"

function Important() {
  const data = [
    {
      id: 1,
      name: "Provide safety and security",
    },
    {
      id: 2,
      name: "Generate financial resources",
    },
    {
      id: 3,
      name: "Life insurance encourages",
    },
    {
      id: 4,
      name: "Promotes economic growth",
    },
    {
      id: 5,
      name: "Source of collecting funds",
    },
    {
      id: 6,
      name: "Spreading of risk & medical",
    },
  ];
  return (
    <>
      <section className="service-three">
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-md-12 col-lg-6">
              <div className="service-three__image">
                <img src={Img} style={{ width: "502px", height: "504px" }}/>
                <div className="service-three__image__caption">
                  <h3 className="count-box service-three__image__caption__count">
                    <CountUp end={2} duration={0}>
                      {" "}
                    </CountUp>
                  </h3>

                  <p className="service-three__image__caption__text">
                    Years Of Experience
                  </p>
                </div>

                <div className="service-three__image__check">
                  <i className="flaticon-tick" />
                  <span>Quality Insurance</span>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="service-three__content">
                <div className="sec-title text-start">
                  <p className="sec-title__tagline">Importance of Insurance</p>

                  <h3 className="sec-title__title">
                    Why the role and importance of insurance explained{" "}
                  </h3>
                </div>

                <ul className="service-three__list list-unstyled">
                  {data.map((item) => (
                    <li key={item.id}>
                      <i className="fas fa-check" />
                      <h3 className="service-three__list__title">
                        <Link href="#">{item.name}</Link>
                      </h3>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Important;
